import { useCallback, useMemo, useState } from 'react';
import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { Text } from '~/components/ui/Text';
import { rage, useInputAction, useObservable } from '~/rage';
import { InputAction, ModalButtonColor, ModalType } from '~/shared';
import { MoneyInput } from '../../components/MoneyInput';
import { setCarMarketState, useLayoutDispatch } from '../../redux';
import { CarMarketState } from '../CarMarket/CarMarket.model';
import {
	StyledButtonsContainer,
	StyledContainer,
} from './CarMarketEdit.styled';

const CarMarketEdit = () => {
	const dispatch = useLayoutDispatch();
	const currentAdvert = useObservable(rage.vehicleMarket.getCurrentAdvert());
	const [value, setValue] = useState(currentAdvert?.price ?? 0);

	const vehicleName = useMemo(() => {
		if (!currentAdvert) return '';
		return rage.vehicles.getVehicleNameByModel(currentAdvert.vehicleModel);
	}, [currentAdvert]);

	const handleBack = useCallback(() => {
		dispatch(setCarMarketState(CarMarketState.InfoSeller));
	}, []);

	useInputAction(InputAction.CommonMenuClose, handleBack);

	const handleSave = useCallback(() => {
		if (!value) {
			return;
		}

		rage.modal.showModal(
			{
				type: ModalType.Default,
				title: 'Подтверждение',
				text: 'Вы действительно хотите сохранить изменения?',
				acceptButton: {
					color: ModalButtonColor.Primary,
					text: 'Сохранить',
				},
				cancelButton: {
					color: ModalButtonColor.Secondary,
					text: 'Отменить',
				},
			},
			(result) => {
				if (result.isAccepted) {
					if (currentAdvert?.vehicleId) {
						rage.vehicleMarket
							.editAdvertPrice(currentAdvert.vehicleId, value)
							.catch((err) => rage.notifications.showException(err));
						dispatch(setCarMarketState(CarMarketState.InfoSeller));
					}
				}
			},
		);
	}, [currentAdvert, value]);

	return (
		<StyledContainer>
			<Text style={{ fontSize: 16, color: '#ffffff', opacity: 0.75 }}>
				Вы действительно хотите выставить {vehicleName} на авторынок?
			</Text>
			<MoneyInput
				value={value}
				onChange={setValue}
				placeholder={'Введите стоимость'}
			/>
			<StyledButtonsContainer>
				<Button
					color={ButtonColors.Default}
					onClick={handleBack}
					height={ButtonHeight.Height50}
				>
					<Text>Отменить</Text>
				</Button>
				<Button
					color={ButtonColors.Select2}
					onClick={handleSave}
					disabled={!value}
					height={ButtonHeight.Height50}
				>
					<Text>Сохранить</Text>
				</Button>
			</StyledButtonsContainer>
		</StyledContainer>
	);
};

export { CarMarketEdit };
